import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";
import { translate } from "app/filters/i18nFilter";
import type { FC } from "react";

const ChangeDateDisclaimer = styled.div`
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 4px;
    padding: 8px;
    display: flex;
    gap: 8px;
    margin-top: 12px;
`;

const ChangeDateDisclaimerText = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[400])};
`;

export const Disclaimer: FC<{ messageKey: string }> = ({ messageKey }) => {
    return (
        <ChangeDateDisclaimer>
            <SWReactIcons
                iconName={"alerts"}
                size="xs"
            />
            <ChangeDateDisclaimerText>{translate(messageKey)}</ChangeDateDisclaimerText>
        </ChangeDateDisclaimer>
    );
};
